module.exports = __webpack_public_path__ + "static/img/far2.e76bcaa7.png";